// PageSkeleton — loader par défaut pour Suspense lazy routes.
// Animation pulse discrète, aligné tokens design.
export function PageSkeleton() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-bg">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
        <p className="text-sm text-ink-soft">Loading…</p>
      </div>
    </div>
  );
}
